import { useParams } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client/core/networkStatus';

import { Page, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { useGetTransactionDetails } from '@occc-app/dataAccessLayer/transaction/queries';

import { TransactionDetails } from './transaction-details.component';
import { breadcrumbLinks } from './transaction-details.constants';

const PAGE_TITLE = 'Transaction Details';

export const TransactionDetailsPageContainer = () => {
  const { transactionId = '' } = useParams<{ transactionId: string }>();
  const { loading, error, data, networkStatus } = useGetTransactionDetails(transactionId);

  useAppLayoutContextConsumer(breadcrumbLinks);

  return (
    <Page browserTabTitle={PAGE_TITLE} pageHeaderProps={{ title: PAGE_TITLE }}>
      <TransactionDetails
        loading={loading && networkStatus !== NetworkStatus.refetch}
        error={error}
        transaction={data}
      />
    </Page>
  );
};
